module.exports = __webpack_public_path__ + "static/media/Desktop_WhatIsCulture_19.551152d4.png";